import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  ListOptions,
} from "./farmList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import {} from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import {
  ShowAlertDialog,
  PaginateList,
} from "@de-prado-dev/react-component-library";
import { useFarm } from "../hook/useFarm";
import * as CenterService from "../../../../services/CenterService";
import { CENTER_TYPES } from "./../../../../constants";

const FarmListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);
  const refresh = () => {
    setForceRefresh(true);
  };

  const columns = [
    {
      header: t("forms.center.table.heads.name"),
      accessorKey: "name",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.center.table.heads.type"),
      accessorKey: "type",
      cell: (info) => {
        const status = CENTER_TYPES.find((pl) => pl.code === info.getValue());
        return (
          <div
            className={
              info.row.original.cancelByTransport ? "text-transport" : ""
            }
          >
            {t(status?.label || info.getValue())}
          </div>
        );
      },
    },
    {
      header: t("forms.center.table.heads.speakers"),
      accessorKey: "userSpeaker",
      cell: (info) =>
        info
          .getValue()
          .map((speaker) => speaker.name)
          .join(", "),
    },
    // {
    //   header: t(" "),
    //   accessorKey: " ",
    //   cell: (info) => renderAction(info.row.original),
    //   size: 80,
    // },
  ];

  /*const goToEdit = (uuid) => {
    navigate(`/user/farm/form/update/${uuid}`);
  };*/

  const renderAction = (data) => {
    return (
      <div className="text-center">
        {/* <ButtonAction
          onClick={() => asignOwnerAndInspectUnit(data.uuid)}
          type="button"
        >
          <i className="fa-regular fa-pen-to-square"></i>
        </ButtonAction> */}
      </div>
    );
  };

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "name";
    }
    const result = await CenterService.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <PaginateList
      refresh={forceRefresh}
      filters={filters}
      columns={columns}
      toList={listData}
      hideColum={hideColumn}
      resize={resize}
      resetRefresh={() => setForceRefresh(false)}
    ></PaginateList>
  );
};

FarmListContainer.propTypes = {
  filters: PropTypes.object,
};

export default FarmListContainer;
